import Cookies from 'js-cookie';

import { getOscConfig } from '@twiliointernal/e2-commons-shared-definitions';

const { currentAccountCookieDomain } = getOscConfig();

export const setCurrentAccountCookies = (accountSid: string): void => {
  //Set cookie for Twilio Console for consistent UX
  Cookies.set('current-account', accountSid, {
    path: '/console',
    domain: currentAccountCookieDomain,
    secure: window.location.protocol.indexOf('https') === 0,
  });
};
